var exports = {
  "GT": "UploadDropZone.module__dropZone___Y0Rnem",
  "xf": "UploadDropZone.module__dropZoneDragging___Y0Rnem",
  "Kk": "UploadDropZone.module__icon___Y0Rnem",
  "h_": "UploadDropZone.module__description___Y0Rnem",
};

module.exports = exports;
